import axios from 'axios'

export const getAssignee = (contactId, user) => {
  return axios.get(`/contacts/assignee/${contactId}?active_division=${user.division_id}`)
}

export const confirmUserPermission = (contactId, user) => {
  return axios.get(`/contacts/hasPermissions/${contactId}?active_division=${user.division_id}`)
}
